export const getCounterText = (value: string | number | null | undefined, maxLength?: number): string => {
  if (!maxLength) return '';
  const strValue: string = value ? value.toString() : '';
  return `${strValue.length}/${maxLength}`;
};
